import React, { useEffect, useState } from 'react'
import { isPermission, isRole } from '../redux/selectors/authSelector';
import { useSelector } from 'react-redux';
import { Topbar } from '../components/include/Topbar';
import Error403Page from './ErrorPage';
import StatCard from '../components/common/StatCard';
import Title from '../components/common/Title';
import { useNavigate } from 'react-router-dom';
import { Postdata } from '../helpers/api.service';
import HttpService from '../helpers/httpServices';

const AdminDashboard = () => {
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole);
    const navigate = useNavigate();

    const [dashboardData, setDashboardData] = useState({
        schools: 0,
        activeSchools: 0,
        loading: true
    });

    const isAccessible = role === "admin" || (permissions && permissions?.includes('view_Admin_Dashboard')) || false;

    const fetchData = async () => {
        try {
            const res = await Postdata(HttpService.school_list);
            if (res.status === 200) {
                setDashboardData({
                    schools: res.data.totalSchool,
                    activeSchools: res.data.activeSchool,
                    loading: false
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setDashboardData((prevState) => ({ ...prevState, loading: false }));
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (!isAccessible) {
        return <Error403Page />;
    }

    return (
        <>
            <Title name="Dashboard" />
            <Topbar title="Dashboard" />
            <div className="p-6 space-y-6 pr-0">
                {dashboardData.loading ? (
                    <div className='flex justify-center items-center'>Loading...</div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="bg-white p-6 rounded-xl shadow hover:shadow-md transition duration-300 border-l-4 border-primary_main">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-800">Pending Approvals</h3>
                                    <p className="text-sm text-gray-500 mt-1">Requests waiting for your action</p>
                                </div>
                                <div>
                                    <svg className="w-12 h-12 text-primary_main" fill="none" stroke="currentColor" strokeWidth="1.5"
                                        viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                            </div>
                            <button
                                onClick={() => navigate('/admin-approvals')}
                                className="mt-4 bg-primary_main hover:bg-primary_main text-white text-sm font-medium py-2 px-4 rounded shadow"
                            >
                                View Requests
                            </button>
                        </div>
                        <div className="bg-white p-6 rounded-xl shadow hover:shadow-md transition duration-300 border-l-4 border-primary_main">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-800">Total Schools</h3>
                                    <h2 className="text-2xl text-bold text-gray-500 mt-1">{dashboardData.schools || '-'}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white p-6 rounded-xl shadow hover:shadow-md transition duration-300 border-l-4 border-primary_main">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-800">Total Active Schools</h3>
                                    <h2 className="text-2xl text-bold text-gray-500 mt-1">{dashboardData.activeSchools || '-'}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default AdminDashboard;
